import { render } from "./ShoprenterAuthView.vue?vue&type=template&id=9db34548"
import script from "./ShoprenterAuthView.vue?vue&type=script&lang=js"
export * from "./ShoprenterAuthView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/ShoprenterAuthView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9db34548"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9db34548', __exports__)) {
    api.reload('9db34548', __exports__)
  }
  
  module.hot.accept("./ShoprenterAuthView.vue?vue&type=template&id=9db34548", () => {
    api.rerender('9db34548', render)
  })

}


export default __exports__